import { makeStyles } from "@material-ui/core/styles";

export const colorPallete = makeStyles({
    //button colors
    root: {
        color: "black"
    },
    deckButtons: {
        color: "rgba(152, 152, 152, 1)"
    },
    primary: {
        background: "linear-gradient(45deg, #00567a 30%, #00567a 90%)",
        color: "#f1f5f9"
    },
    secondaryBlue: {
        background:
            "linear-gradient(45deg, rgba(98, 181, 229, .5), rgba(98, 181, 229, .5))",
        color: "rgba(91, 114, 127, .5)"
    },
    secondaryGreen: {
        background:
            "linear-gradient(45deg, rgba(111, 162, 135, .4), rgba(111, 162, 135, .4))",
        color: "rgba(93, 104, 98, 1)"
    },
    neutralLight: {
        background: "linear-gradient(45deg, rgba(0, 0, 0 .15), rgba(0, 0, 0 .15))",
        color: "rgba(105, 105, 105, 1)"
    },
    neutralDark: {
        background: "linear-gradient(45deg, #7c878e 30%, #7c878e 90%)",
        color: "#f1f5f9"
    },
    neutralGreen: {
        background:
            "linear-gradient(45deg, rgba(229, 240, 223, 1) 30%, rgba(229, 240, 223, 1) 90%)",
        color: "rgba(152, 152, 152, 1)",
        ":hover": {
            background:
                "linear-gradient(45deg, rgba(229, 240, 223, 1) 30%, rgba(229, 240, 223, 1) 90%)"
        }
    },
    neutralBlue: {
        background:
            "linear-gradient(45deg, rgba(178, 199, 227, 1), rgba(178, 199, 227, 1))",
        color: "rgba(152, 152, 152, 1)"
    },
    accentGreen: {
        background: "linear-gradient(45deg, #a1d884 30%, #a1d884 90%)",
        color: "rgba(152, 152, 152, 1)"
    },
    accentAqua: {
        background:
            "linear-gradient(45deg, rgba(98, 181, 229, .5), rgba(98, 181, 229, .5))",
        color: "rgba(0, 0, 0, .5)"
    },
    accentBlue: {
        background:
            "linear-gradient(45deg, rgba(0, 86, 122, .45), rgba(0, 86, 122, .45))",
        color: "rgba(65, 84, 92, 1)"
    },
    accentRed: {
        background:
            "linear-gradient(45deg, rgba(214, 164, 97, .5), rgba(214, 164, 97, .5))",
        color: "rgba(111, 99, 82, 1)"
    },
    accentOrange: {
        background: "linear-gradient(45deg, #d6a461 30%, #d6a461 90%)",
        color: "#f1f5f9"
    },
    accentYellow: {
        background:
            "linear-gradient(45deg, rgba(210, 215, 85, .5), rgba(210, 215, 85, .5))",
        color: "rgba(110, 112, 79, 1)"
    },
    questionButtons: {
        height: "100%",
        background:
            "linear-gradient(45deg, rgba(0, 0, 0, .08) 30%, rgba(0, 0, 0, .08) 90%) !important",
        color: "rgba(0, 0, 0, .9) !important",
        width: "100%",
        padding: "10px !important",
        "&:disabled": {
            opacity: 0.3
        }
    },
    trueQuestionButtons: {
        height: "100%",
        background:
            "linear-gradient(45deg, rgba(98, 181, 229, .3) 30%, rgba(98, 181, 229, .3) 90%) !important",
        color: "rgba(0, 0, 0, .9)",
        width: "100%",
        padding: "10px !important"
    },
    testTableButtons: {
        background:
            "linear-gradient(45deg, rgba(241, 249, 255, 1), rgba(241, 249, 255, 1))"
    },
    //Text Colors
    neutralLightText: {
        color: "rgba(112, 112, 112, 1)"
    },
    neutralGreenText: {
        color: "rgba(114, 120, 111, 1)"
    },
    neutralBlueText: {
        color: "rgba(89, 99, 113, 1)"
    },
    darkBlueText: {
        color: "rgba(8, 86, 122, 1)"
    },
    lightBlueText: {
        color: "rgba(120, 124, 127, 1)"
    },
    primaryText: {
        color: "#00567a"
    },
    accentRedText: {
        color: "rgba(111, 99, 82, 1) !important"
    },
    accentYellowText: {
        color: "rgba(110, 112, 79, 1) !important"
    },
    accentBlueText: {
        color: "rgba(65, 84, 92, 1)"
    },
    secondaryBlueText: {
        color: "rgba(91, 114, 127, .5) !important"
    },
    secondaryGreenText: {
        color: "rgba(93, 104, 98, 1) !important"
    },

    //Card Colors
    neutralBlueCard: {
        background: "rgba(178, 199, 227, 1) !important",
        color: "rgba(152, 152, 152, 1) !important",
        border: "1px solid !important",
        borderColor: "rgba(144, 155, 169, 1) !important",
        "&:hover": {
            background:
                "linear-gradient(45deg, rgba(178, 199, 227, 1) 30%, rgba(178, 199, 227, 1) 90%) !important"
        }
    },
    neutralGreenCard: {
        background: "rgba(229, 240, 223, 1) !important",
        border: "1px solid !important",
        borderColor: "rgba(170, 175, 167, 1) !important",
        color: "rgba(152, 152, 152, 1) !important",
        "&:hover": {
            background:
                "linear-gradient(45deg, rgba(229, 240, 223, 1) 30%, rgba(229, 240, 223, 1) 90%) !important"
        }
    },
    accentBlueCard: {
        background: "rgba(0, 86, 122, .45) !important",
        color: "rgba(65, 84, 92, 1) !important",
        border: "1px solid !important",
        borderColor: "rgba(122, 141, 150, 1) !important",
        "&:hover": {
            background:
                "linear-gradient(45deg, rgba(0, 86, 122, .45) 30%, rgba(0, 86, 122, .45) 90%) !important"
        }
    },
    secondaryBlueCard: {
        background: "rgba(98, 181, 229, .5) !important",
        color: "rgba(91, 114, 127, .5) !important",
        border: "1px solid !important",
        borderColor: "rgba(140, 161, 173, 1) !important",
        "&:hover": {
            background:
                "linear-gradient(45deg, rgba(98, 181, 229, .5) 30%, rgba(98, 181, 229, .5) 90%) !important"
        }
    },
    secondaryGreenCard: {
        background: "rgba(111, 162, 135, .4) !important",
        color: "rgba(93, 104, 98, 1) !important",
        border: "1px solid !important",
        borderColor: "rgba(151, 161, 156, 1) !important",
        "&:hover": {
            background:
                "linear-gradient(45deg, rgba(111, 162, 135, .4) 30%, rgba(111, 162, 135, .4) 90%) !important"
        }
    },
    neutralLightCard: {
        background: "rgba(0, 0, 0 .15) !important",
        color: "rgba(105, 105, 105, 1) !important",
        border: "1px solid !important",
        borderColor: "rgba(165, 165, 165, 1) !important",
        "&:hover": {
            background:
                "linear-gradient(45deg, rgba(0, 0, 0 .15) 30%, rgba(0, 0, 0 .15) 90%) !important"
        }
    },
    accentYellowCard: {
        background: "rgba(210, 215, 85, .5) !important",
        color: "rgba(110, 112, 79, 1) !important",
        border: "1px solid !important",
        borderColor: "rgba(168, 170, 137, 1) !important",
        "&:hover": {
            background:
                "linear-gradient(45deg, rgba(210, 215, 85, .5) 30%, rgba(210, 215, 85, .5) 90%) !important"
        }
    },
    accentRedCard: {
        background: "rgba(214, 164, 97, .5) !important",
        color: "rgba(111, 99, 82, 1) !important",
        border: "1px solid !important",
        borderColor: "rgba(169, 157, 140, 1) !important",
        "&:hover": {
            background:
                "linear-gradient(45deg, rgba(214, 164, 97, .5) 30%, rgba(214, 164, 97, .5) 90%) !important"
        }
    },
    //
    lightBlueCard: {
        background: "rgba(241, 249, 255, 1)",
        color: "rgba(120, 124, 127, 1)"
    },
    correctGradedButtons: {
        height: "100%",
        background:
            "linear-gradient(45deg, rgba(161, 216, 132, .5) 30%, rgba(161, 216, 132, .5) 90%) !important",
        color: "rgba(0, 0, 0, .9)",
        width: "100%",
        padding: "10px !important"
    },
    incorrectGradedButtons: {
        height: "100%",
        background:
            "linear-gradient(45deg, rgba(192, 125, 89, .5) 30%, rgba(192, 125, 89, .5) 90%) !important",
        color: "rgba(0, 0, 0, .9)",
        width: "100%",
        padding: "10px !important"
    },
    correctQuestionButtons: {
        height: "100%",
        background:
            "linear-gradient(45deg, rgba(161, 216, 132, .5) 30%, rgba(161, 216, 132, .5) 90%) !important",
        color: "rgba(0, 0, 0, .9)",
        width: "100%",
        padding: "10px !important"
    },
    incorrectQuestionButtons: {
        height: "100%",
        background:
            "linear-gradient(45deg, rgba(192, 125, 89, .5) 30%, rgba(192, 125, 89, .5) 90%) !important",
        color: "rgba(0, 0, 0, .9)",
        width: "100%",
        padding: "10px !important"
    },
    submitButtons: {
        height: "4em",
        background:
            "linear-gradient(45deg, rgba(0, 0, 0, .08) 30%, rgba(0, 0, 0, .08) 90%) !important",
        color: "rgba(0, 0, 0, .9) !important",
        width: "100%",
        marginBottom: "15px",
        padding: "10px !important",
        "&:disabled": {
            background:
                "linear-gradient(45deg, rgba(0, 0, 0, .08) 30%, rgba(0, 0, 0, .08) 90%) !important",
            color: "rgba(0, 0, 0, .9) !important"
        }
    }
});
